import { CommonLogin } from "./commonLogin/CommonLogin";
import { SsoLogin } from "./ssoLogin/SsoLogin";
import { NoLogin } from "./noLogin/NoLogin";
import { isSSO } from "../../store/info/info.selectors";
import { isNoLoginPage } from "../../store/config/config.selectors";

export const loginComponentSelector = state =>
  isNoLoginPage(state) ? NoLogin : isSSO(state) ? SsoLogin : CommonLogin;
